var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49975 9.00025H1.49975C1.36634 9.00827 1.23274 8.9879 1.10778 8.94048C0.982819 8.89306 0.869339 8.81968 0.774831 8.72517C0.680323 8.63066 0.606938 8.51718 0.55952 8.39222C0.512102 8.26726 0.49173 8.13366 0.49975 8.00025V1.00025C0.49173 0.866838 0.512102 0.73324 0.55952 0.60828C0.606938 0.48332 0.680323 0.369841 0.774831 0.275332C0.869339 0.180824 0.982819 0.107438 1.10778 0.0600204C1.23274 0.0126028 1.36634 -0.00776863 1.49975 0.000250816H2.49975V9.00025Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.0005H9.5V14.0005C9.51604 14.2673 9.4753 14.5345 9.38046 14.7844C9.28562 15.0344 9.13885 15.2613 8.94984 15.4503C8.76082 15.6394 8.53386 15.7861 8.28394 15.881C8.03402 15.9758 7.76683 16.0165 7.5 16.0005L4.5 9.0005V0.000501633H12.5C13.1894 -0.00819397 13.8595 0.228364 14.3907 0.667963C14.9219 1.10756 15.2796 1.7216 15.4 2.4005L16.4 7.6005C16.4706 7.88733 16.4747 8.18652 16.4119 8.47517C16.3492 8.76382 16.2212 9.03429 16.0379 9.2659C15.8545 9.4975 15.6206 9.6841 15.3541 9.81143C15.0875 9.93875 14.7954 10.0034 14.5 10.0005Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.e8c437dfbf18b816734c961f382a9da9.svg";
export { ForwardRef as ReactComponent };